<!-- 3D Line Dialog - Kompakt Tasarım -->

<!-- Ana İçerik Şablonu -->
<ng-template #dialogContent>
    <div class="page-container compact">

        <!-- ============================================== -->
        <!-- SAYFA 0: ANA SAYFA (KOMPAKT) -->
        <!-- ============================================== -->
        @if (aktifSayfa === 0) {
        <div class="page ana-sayfa">

            <!-- İsim -->
            <div class="form-group compact">
                <label class="form-label">İsim</label>
                <input type="text" class="form-input" [(ngModel)]="isim" placeholder="Çizgi.X">
            </div>

            <!-- Yöntem Seçimi -->
            <div class="form-group compact">
                <label class="form-label">Yöntem</label>
                <select class="form-input select-input" [(ngModel)]="seciliYontem" (ngModelChange)="yontemDegisti($event)">
                    @for (yontem of yontemSecenekleri; track yontem.deger) {
                    <option [value]="yontem.deger">{{ yontem.etiket }}</option>
                    }
                </select>
            </div>

            <!-- Aktif Body (kompakt) -->
            @if (!duzenleModu) {
            <div class="form-group compact aktif-body-group">
                <div class="body-header">
                    <label class="form-label">Body</label>
                    <label class="body-toggle mini">
                        <input type="checkbox" [(ngModel)]="aktifBodyeEkle">
                    </label>
                </div>
                @if (aktifBodyeEkle) {
                <div class="body-picker compact">
                    <input type="text" class="form-input body-input"
                           [value]="seciliAktifBodyIsim" readonly
                           [class.selecting]="bodySecModu">
                    <button class="pick-btn mini" [class.active]="bodySecModu"
                            (click)="bodySecBaslat()" title="Seç">
                        <i class="crosshairs icon"></i>
                    </button>
                </div>
                }
            </div>
            }

            <!-- Yönteme Göre Parametreler -->

            <!-- Nokta → Nokta -->
            @if (seciliYontem === 'noktadanNoktaya') {
            <div class="point-select-row">
                <button class="point-btn" [class.active]="noktaSecModu === 'baslangic'"
                        (click)="noktaSecBaslat('baslangic')">
                    <i class="crosshairs icon"></i>
                    <span>Başlangıç</span>
                    <small>({{baslangicX|number:'1.0-0'}}, {{baslangicY|number:'1.0-0'}}, {{baslangicZ|number:'1.0-0'}})</small>
                </button>
                <button class="point-btn" [class.active]="noktaSecModu === 'bitis'"
                        (click)="noktaSecBaslat('bitis')">
                    <i class="crosshairs icon"></i>
                    <span>Bitiş</span>
                    <small>({{bitisX|number:'1.0-0'}}, {{bitisY|number:'1.0-0'}}, {{bitisZ|number:'1.0-0'}})</small>
                </button>
            </div>
            }

            <!-- Nokta + Yön + Uzunluk -->
            @if (seciliYontem === 'noktadanYonUzunluk') {
            <div class="point-select-row single">
                <button class="point-btn" [class.active]="noktaSecModu === 'baslangic'"
                        (click)="noktaSecBaslat('baslangic')">
                    <i class="crosshairs icon"></i>
                    <span>Başlangıç</span>
                    <small>({{baslangicX|number:'1.0-0'}}, {{baslangicY|number:'1.0-0'}}, {{baslangicZ|number:'1.0-0'}})</small>
                </button>
            </div>
            <div class="param-row">
                <div class="param-group">
                    <label>Yön</label>
                    <div class="dir-quick">
                        <button class="dir-mini" [class.active]="yonSecTipi === 'yuzey'" (click)="yonSecBaslat('yuzey')" title="Yüzey"><i class="square outline icon"></i></button>
                        <button class="dir-mini" [class.active]="yonSecTipi === 'kenar'" (click)="yonSecBaslat('kenar')" title="Kenar"><i class="minus icon"></i></button>
                        <button class="dir-mini" [class.active]="yonSecTipi === 'ikiNokta'" (click)="yonSecBaslat('ikiNokta')" title="2 Nokta"><i class="arrows alternate icon"></i></button>
                    </div>
                </div>
            </div>
            <div class="param-row">
                <div class="param-field full">
                    <label>Uzunluk</label>
                    <input type="number" [(ngModel)]="uzunluk" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10" min="1">
                </div>
            </div>
            }

            <!-- Merkez + Çift Yön -->
            @if (seciliYontem === 'merkezdenCift') {
            <div class="point-select-row single">
                <button class="point-btn" [class.active]="noktaSecModu === 'baslangic'"
                        (click)="noktaSecBaslat('baslangic')">
                    <i class="crosshairs icon"></i>
                    <span>Merkez</span>
                    <small>({{baslangicX|number:'1.0-0'}}, {{baslangicY|number:'1.0-0'}}, {{baslangicZ|number:'1.0-0'}})</small>
                </button>
            </div>
            <div class="param-row">
                <div class="param-group">
                    <label>Yön</label>
                    <div class="dir-quick">
                        <button class="dir-mini" [class.active]="yonSecTipi === 'yuzey'" (click)="yonSecBaslat('yuzey')" title="Yüzey"><i class="square outline icon"></i></button>
                        <button class="dir-mini" [class.active]="yonSecTipi === 'kenar'" (click)="yonSecBaslat('kenar')" title="Kenar"><i class="minus icon"></i></button>
                        <button class="dir-mini" [class.active]="yonSecTipi === 'ikiNokta'" (click)="yonSecBaslat('ikiNokta')" title="2 Nokta"><i class="arrows alternate icon"></i></button>
                    </div>
                </div>
            </div>
            <div class="param-row">
                <div class="param-field full">
                    <label>Uzunluk</label>
                    <input type="number" [(ngModel)]="uzunluk" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10" min="1">
                </div>
            </div>
            }

            <!-- Nokta + Açı + Uzunluk -->
            @if (seciliYontem === 'noktadanAciUzunluk') {
            <div class="point-select-row single">
                <button class="point-btn" [class.active]="noktaSecModu === 'baslangic'"
                        (click)="noktaSecBaslat('baslangic')">
                    <i class="crosshairs icon"></i>
                    <span>Başlangıç</span>
                    <small>({{baslangicX|number:'1.0-0'}}, {{baslangicY|number:'1.0-0'}}, {{baslangicZ|number:'1.0-0'}})</small>
                </button>
            </div>
            <div class="param-row">
                <div class="param-field full">
                    <label>Açı</label>
                    <input type="number" [(ngModel)]="aciDerece" (ngModelChange)="cizgiyiAnlikGuncelle()" step="15">
                    <span class="unit">°</span>
                </div>
            </div>
            <div class="param-row">
                <div class="param-field full">
                    <label>Uzunluk</label>
                    <input type="number" [(ngModel)]="uzunluk" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10" min="1">
                </div>
            </div>
            }

            <!-- 3D Açı -->
            @if (seciliYontem === 'noktadan3DAci') {
            <div class="point-select-row single">
                <button class="point-btn" [class.active]="noktaSecModu === 'baslangic'"
                        (click)="noktaSecBaslat('baslangic')">
                    <i class="crosshairs icon"></i>
                    <span>Başlangıç</span>
                    <small>({{baslangicX|number:'1.0-0'}}, {{baslangicY|number:'1.0-0'}}, {{baslangicZ|number:'1.0-0'}})</small>
                </button>
            </div>
            <div class="param-row triple">
                <div class="param-field">
                    <label>θ</label>
                    <input type="number" [(ngModel)]="thetaDerece" (ngModelChange)="cizgiyiAnlikGuncelle()" step="15">
                </div>
                <div class="param-field">
                    <label>φ</label>
                    <input type="number" [(ngModel)]="phiDerece" (ngModelChange)="cizgiyiAnlikGuncelle()" step="15">
                </div>
                <div class="param-field">
                    <label>L</label>
                    <input type="number" [(ngModel)]="uzunluk" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
            </div>
            }

            <!-- Yatay -->
            @if (seciliYontem === 'yatay') {
            <div class="param-row">
                <div class="param-field">
                    <label>X1</label>
                    <input type="number" [(ngModel)]="baslangicX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
                <div class="param-field">
                    <label>X2</label>
                    <input type="number" [(ngModel)]="bitisX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
            </div>
            <div class="param-row">
                <div class="param-field">
                    <label>Y</label>
                    <input type="number" [(ngModel)]="baslangicY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
                <div class="param-field">
                    <label>Z</label>
                    <input type="number" [(ngModel)]="baslangicZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
            </div>
            }

            <!-- Dikey -->
            @if (seciliYontem === 'dikey') {
            <div class="param-row">
                <div class="param-field">
                    <label>Y1</label>
                    <input type="number" [(ngModel)]="baslangicY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
                <div class="param-field">
                    <label>Y2</label>
                    <input type="number" [(ngModel)]="bitisY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
            </div>
            <div class="param-row">
                <div class="param-field">
                    <label>X</label>
                    <input type="number" [(ngModel)]="baslangicX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
                <div class="param-field">
                    <label>Z</label>
                    <input type="number" [(ngModel)]="baslangicZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
            </div>
            }

            <!-- Derinlik -->
            @if (seciliYontem === 'derinlik') {
            <div class="param-row">
                <div class="param-field">
                    <label>Z1</label>
                    <input type="number" [(ngModel)]="baslangicZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
                <div class="param-field">
                    <label>Z2</label>
                    <input type="number" [(ngModel)]="bitisZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
            </div>
            <div class="param-row">
                <div class="param-field">
                    <label>X</label>
                    <input type="number" [(ngModel)]="baslangicX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
                <div class="param-field">
                    <label>Y</label>
                    <input type="number" [(ngModel)]="baslangicY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="10">
                </div>
            </div>
            }

            @if (noktaSecModu) {
            <div class="pick-hint">3D görünümde tıklayın...</div>
            }

            <!-- Renk -->
            <div class="color-row">
                <label>Renk</label>
                <input type="color" [(ngModel)]="renk" (ngModelChange)="renkDegisti()">
            </div>

            <!-- Alt Butonlar -->
            <div class="footer-buttons compact">
                <button class="btn btn-icon" (click)="sayfayaGit(1)" title="Ayarlar">
                    <i class="cog icon"></i>
                </button>
                <button class="btn btn-icon" (click)="sayfayaGit(2)" title="Koordinatlar">
                    <i class="map marker alternate icon"></i>
                </button>
                @if (duzenleModu) {
                <button class="btn btn-icon btn-delete" (click)="cizgiSil()" title="Sil">
                    <i class="trash icon"></i>
                </button>
                }
                <div class="spacer"></div>
                <button class="btn btn-cancel" (click)="dialogKapat()">
                    <i class="close icon"></i>
                </button>
                <button class="btn btn-primary" (click)="olusturVeyaGuncelle()">
                    <i class="check icon"></i>
                </button>
            </div>

        </div>
        }

        <!-- ============================================== -->
        <!-- SAYFA 1: AYARLAR -->
        <!-- ============================================== -->
        @if (aktifSayfa === 1) {
        <div class="page ayarlar-sayfa">

            <div class="page-header compact">
                <button class="back-btn" (click)="geriGit()">
                    <i class="arrow left icon"></i>
                </button>
                <span class="page-title">Ayarlar</span>
            </div>

            <!-- Tab Bar -->
            <div class="tab-bar compact">
                <button class="tab-btn" [class.active]="aktifAyarTab === 'gorunum'" (click)="tabDegistir('gorunum')">Görünüm</button>
                <button class="tab-btn" [class.active]="aktifAyarTab === 'ok'" (click)="tabDegistir('ok')">Ok</button>
                <button class="tab-btn" [class.active]="aktifAyarTab === 'diger'" (click)="tabDegistir('diger')">Diğer</button>
            </div>

            <div class="tab-content compact">

                <!-- Görünüm Tab -->
                @if (aktifAyarTab === 'gorunum') {
                <div class="tab-pane">
                    <div class="setting-row">
                        <label>Çizgi Tipi</label>
                        <select [(ngModel)]="cizgiTipi">
                            @for (tip of cizgiTipiSecenekleri; track tip.deger) {
                            <option [value]="tip.deger">{{ tip.etiket }}</option>
                            }
                        </select>
                    </div>
                    <div class="setting-row">
                        <label>Kalınlık</label>
                        <input type="number" [(ngModel)]="kalinlik" (ngModelChange)="kalinlikDegisti()" min="0.1" max="10" step="0.5">
                        @if (cizgiTipi !== 'Line2') {
                        <span class="hint" title="WebGL: 1px sabit">⚠</span>
                        }
                    </div>
                    <div class="setting-row">
                        <label>Opaklık</label>
                        <div class="range-group">
                            <input type="range" [(ngModel)]="opaklik" (ngModelChange)="opaklikDegisti()" min="0" max="1" step="0.1">
                            <span class="range-value">{{ opaklik | number:'1.1-1' }}</span>
                        </div>
                    </div>
                    <div class="setting-row">
                        <label>Stil</label>
                        <select [(ngModel)]="stil" (ngModelChange)="stilDegisti()">
                            @for (s of stilSecenekleri; track s.deger) {
                            <option [value]="s.deger">{{ s.etiket }}</option>
                            }
                        </select>
                    </div>
                    @if (stil !== 'duz') {
                    <div class="setting-row sub">
                        <label>Kesik</label>
                        <input type="number" [(ngModel)]="kesikliBoyut" min="1" step="1">
                    </div>
                    <div class="setting-row sub">
                        <label>Aralık</label>
                        <input type="number" [(ngModel)]="kesikliAralik" min="1" step="1">
                    </div>
                    }
                </div>
                }

                <!-- Ok Tab -->
                @if (aktifAyarTab === 'ok') {
                <div class="tab-pane">
                    <div class="setting-row">
                        <label>Başlangıç</label>
                        <select [(ngModel)]="okBaslangic">
                            @for (ok of okTipiSecenekleri; track ok.deger) {
                            <option [value]="ok.deger">{{ ok.etiket }}</option>
                            }
                        </select>
                    </div>
                    <div class="setting-row">
                        <label>Bitiş</label>
                        <select [(ngModel)]="okBitis">
                            @for (ok of okTipiSecenekleri; track ok.deger) {
                            <option [value]="ok.deger">{{ ok.etiket }}</option>
                            }
                        </select>
                    </div>
                    <div class="setting-row">
                        <label>Boyut</label>
                        <input type="number" [(ngModel)]="okBoyut" min="0.01" step="0.05">
                    </div>
                </div>
                }

                <!-- Diğer Tab -->
                @if (aktifAyarTab === 'diger') {
                <div class="tab-pane">
                    <div class="setting-row checkbox">
                        <label><input type="checkbox" [(ngModel)]="enUstte" (ngModelChange)="enUsteDegisti()"> En Üstte</label>
                        <span class="hint-icon" title="Depth test kapalı">?</span>
                    </div>
                    <div class="setting-row checkbox">
                        <label><input type="checkbox" [(ngModel)]="renderEt" (ngModelChange)="renderEtDegisti()"> Render</label>
                    </div>
                    <div class="setting-row checkbox">
                        <label><input type="checkbox" [(ngModel)]="secilebilir" (ngModelChange)="secilebilirDegisti()"> Seçilebilir</label>
                    </div>
                    <div class="setting-row">
                        <label>Katman</label>
                        <input type="number" [(ngModel)]="katman" min="0" max="31" step="1">
                    </div>
                    <div class="setting-row">
                        <button class="btn btn-reset btn-small" (click)="sifirla()">
                            <i class="redo icon"></i> Sıfırla
                        </button>
                    </div>
                </div>
                }

            </div>

        </div>
        }

        <!-- ============================================== -->
        <!-- SAYFA 2: KOORDİNATLAR -->
        <!-- ============================================== -->
        @if (aktifSayfa === 2) {
        <div class="page koordinat-sayfa">

            <div class="page-header compact">
                <button class="back-btn" (click)="geriGit()">
                    <i class="arrow left icon"></i>
                </button>
                <span class="page-title">Koordinatlar</span>
            </div>

            <div class="coordinates-section compact">

                <!-- Nokta → Nokta -->
                @if (seciliYontem === 'noktadanNoktaya' || duzenleModu) {
                <div class="coord-group">
                    <div class="group-header">
                        <label class="group-label">Başlangıç</label>
                        <button class="pick-btn mini" [class.active]="noktaSecModu === 'baslangic'"
                                (click)="noktaSecBaslat('baslangic')">
                            <i class="crosshairs icon"></i>
                        </button>
                    </div>
                    <div class="coord-inputs">
                        <div class="coord-input"><span>X</span><input type="number" [(ngModel)]="baslangicX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                        <div class="coord-input"><span>Y</span><input type="number" [(ngModel)]="baslangicY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                        <div class="coord-input"><span>Z</span><input type="number" [(ngModel)]="baslangicZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    </div>
                </div>
                <div class="coord-group">
                    <div class="group-header">
                        <label class="group-label">Bitiş</label>
                        <button class="pick-btn mini" [class.active]="noktaSecModu === 'bitis'"
                                (click)="noktaSecBaslat('bitis')">
                            <i class="crosshairs icon"></i>
                        </button>
                    </div>
                    <div class="coord-inputs">
                        <div class="coord-input"><span>X</span><input type="number" [(ngModel)]="bitisX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                        <div class="coord-input"><span>Y</span><input type="number" [(ngModel)]="bitisY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                        <div class="coord-input"><span>Z</span><input type="number" [(ngModel)]="bitisZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    </div>
                </div>
                }

                <!-- Nokta + Yön + Uzunluk / Merkezden Çift -->
                @if (seciliYontem === 'noktadanYonUzunluk' || seciliYontem === 'merkezdenCift') {
                <div class="coord-group">
                    <div class="group-header">
                        <label class="group-label">{{ seciliYontem === 'merkezdenCift' ? 'Merkez' : 'Başlangıç' }}</label>
                        <button class="pick-btn mini" [class.active]="noktaSecModu === 'baslangic'"
                                (click)="noktaSecBaslat('baslangic')">
                            <i class="crosshairs icon"></i>
                        </button>
                    </div>
                    <div class="coord-inputs">
                        <div class="coord-input"><span>X</span><input type="number" [(ngModel)]="baslangicX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                        <div class="coord-input"><span>Y</span><input type="number" [(ngModel)]="baslangicY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                        <div class="coord-input"><span>Z</span><input type="number" [(ngModel)]="baslangicZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    </div>
                </div>
                <div class="coord-group">
                    <div class="group-header">
                        <label class="group-label">Yön</label>
                        <div class="pick-btn-group">
                            <button class="pick-btn mini" [class.active]="yonSecTipi === 'yuzey'" (click)="yonSecBaslat('yuzey')" title="Yüzey"><i class="square outline icon"></i></button>
                            <button class="pick-btn mini" [class.active]="yonSecTipi === 'kenar'" (click)="yonSecBaslat('kenar')" title="Kenar"><i class="minus icon"></i></button>
                            <button class="pick-btn mini" [class.active]="yonSecTipi === 'ikiNokta'" (click)="yonSecBaslat('ikiNokta')" title="2 Nokta"><i class="arrows alternate icon"></i></button>
                        </div>
                    </div>
                    <div class="direction-buttons compact">
                        <button class="dir-btn" (click)="hizliYonSec(1,0,0)" [class.active]="yonX===1 && yonY===0 && yonZ===0">+X</button>
                        <button class="dir-btn" (click)="hizliYonSec(-1,0,0)" [class.active]="yonX===-1 && yonY===0 && yonZ===0">-X</button>
                        <button class="dir-btn" (click)="hizliYonSec(0,1,0)" [class.active]="yonX===0 && yonY===1 && yonZ===0">+Y</button>
                        <button class="dir-btn" (click)="hizliYonSec(0,-1,0)" [class.active]="yonX===0 && yonY===-1 && yonZ===0">-Y</button>
                        <button class="dir-btn" (click)="hizliYonSec(0,0,1)" [class.active]="yonX===0 && yonY===0 && yonZ===1">+Z</button>
                        <button class="dir-btn" (click)="hizliYonSec(0,0,-1)" [class.active]="yonX===0 && yonY===0 && yonZ===-1">-Z</button>
                    </div>
                </div>
                <div class="inline-field compact">
                    <label>Uzunluk</label>
                    <input type="number" [(ngModel)]="uzunluk" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1" min="0.1">
                </div>
                }

                <!-- Nokta + Açı + Uzunluk -->
                @if (seciliYontem === 'noktadanAciUzunluk') {
                <div class="coord-group">
                    <div class="group-header">
                        <label class="group-label">Başlangıç</label>
                        <button class="pick-btn mini" [class.active]="noktaSecModu === 'baslangic'" (click)="noktaSecBaslat('baslangic')">
                            <i class="crosshairs icon"></i>
                        </button>
                    </div>
                    <div class="coord-inputs">
                        <div class="coord-input"><span>X</span><input type="number" [(ngModel)]="baslangicX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                        <div class="coord-input"><span>Y</span><input type="number" [(ngModel)]="baslangicY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                        <div class="coord-input"><span>Z</span><input type="number" [(ngModel)]="baslangicZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    </div>
                </div>
                <div class="inline-row compact">
                    <div class="inline-field"><label>Açı</label><input type="number" [(ngModel)]="aciDerece" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"><span class="unit">°</span></div>
                    <div class="inline-field"><label>Uzunluk</label><input type="number" [(ngModel)]="uzunluk" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                </div>
                }

                <!-- 3D Açı -->
                @if (seciliYontem === 'noktadan3DAci') {
                <div class="coord-group">
                    <div class="group-header">
                        <label class="group-label">Başlangıç</label>
                        <button class="pick-btn mini" [class.active]="noktaSecModu === 'baslangic'" (click)="noktaSecBaslat('baslangic')">
                            <i class="crosshairs icon"></i>
                        </button>
                    </div>
                    <div class="coord-inputs">
                        <div class="coord-input"><span>X</span><input type="number" [(ngModel)]="baslangicX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                        <div class="coord-input"><span>Y</span><input type="number" [(ngModel)]="baslangicY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                        <div class="coord-input"><span>Z</span><input type="number" [(ngModel)]="baslangicZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    </div>
                </div>
                <div class="inline-row compact">
                    <div class="inline-field"><label>θ</label><input type="number" [(ngModel)]="thetaDerece" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"><span class="unit">°</span></div>
                    <div class="inline-field"><label>φ</label><input type="number" [(ngModel)]="phiDerece" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"><span class="unit">°</span></div>
                    <div class="inline-field"><label>L</label><input type="number" [(ngModel)]="uzunluk" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                </div>
                }

                <!-- Yatay -->
                @if (seciliYontem === 'yatay') {
                <div class="inline-row compact">
                    <div class="inline-field"><label>X1</label><input type="number" [(ngModel)]="baslangicX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    <div class="inline-field"><label>X2</label><input type="number" [(ngModel)]="bitisX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                </div>
                <div class="inline-row compact">
                    <div class="inline-field"><label>Y</label><input type="number" [(ngModel)]="baslangicY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    <div class="inline-field"><label>Z</label><input type="number" [(ngModel)]="baslangicZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                </div>
                }

                <!-- Dikey -->
                @if (seciliYontem === 'dikey') {
                <div class="inline-row compact">
                    <div class="inline-field"><label>Y1</label><input type="number" [(ngModel)]="baslangicY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    <div class="inline-field"><label>Y2</label><input type="number" [(ngModel)]="bitisY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                </div>
                <div class="inline-row compact">
                    <div class="inline-field"><label>X</label><input type="number" [(ngModel)]="baslangicX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    <div class="inline-field"><label>Z</label><input type="number" [(ngModel)]="baslangicZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                </div>
                }

                <!-- Derinlik -->
                @if (seciliYontem === 'derinlik') {
                <div class="inline-row compact">
                    <div class="inline-field"><label>Z1</label><input type="number" [(ngModel)]="baslangicZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    <div class="inline-field"><label>Z2</label><input type="number" [(ngModel)]="bitisZ" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                </div>
                <div class="inline-row compact">
                    <div class="inline-field"><label>X</label><input type="number" [(ngModel)]="baslangicX" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                    <div class="inline-field"><label>Y</label><input type="number" [(ngModel)]="baslangicY" (ngModelChange)="cizgiyiAnlikGuncelle()" step="1"></div>
                </div>
                }

            </div>

        </div>
        }

    </div>
</ng-template>


<!-- FikoDialogService Modu -->
@if (pencere) {
<div class="fiko-3d-line-content-only compact">
    <ng-container *ngTemplateOutlet="dialogContent"></ng-container>
</div>
}

<!-- Standalone Mod -->
@if (!pencere && gorunur) {
<div class="fiko-3d-line-dialog-overlay" (click)="kapat()">
    <div class="fiko-3d-line-dialog compact" (click)="$event.stopPropagation()">
        <div class="dialog-header compact">
            <i class="pencil icon"></i>
            <span>{{ duzenleModu ? 'Düzenle' : '3D Çizgi' }}</span>
            <button class="close-btn" (click)="kapat()"><i class="close icon"></i></button>
        </div>
        <div class="dialog-content">
            <ng-container *ngTemplateOutlet="dialogContent"></ng-container>
        </div>
    </div>
</div>
}
